<template>
  <b-modal
    id="postVideoModal"
    :headerClass="`add-vello-icon`"
    centered
    hide-footer
    v-model="postModalShown"
    size="lg"
    no-close-on-backdrop
    @hidden="onModalHidden"
    :dialog-class="{ 'capture-screen': !form.video_raw }"
  >
    <b-form @submit.prevent="onSubmit">
      <b-row no-gutters>
        <b-col cols="12" class="mb-0 position-relative">
          <CameraRecorder
            @change="onRecordFinished"
            :hide-record-button="!!form.video_raw"
          />
          <div v-if="is_file && form.video_raw">
            File: {{ form.video_raw.name }}
          </div>
        </b-col>
        <b-col cols="12" class="mb-0 mt-3" v-show="form.video_raw">
          <b-form-group class="col-12 mb-3">
            <h6>Hashtags</h6>
            <b-form-input
              v-model="form.hashtags"
              class="form-control effect-26 mb-1"
              type="text"
              required
            ></b-form-input>
            <div class="hashtags-display text-gold">{{ hashtagsDisplay }}</div>
          </b-form-group>
          <b-form-group class="col-12 mb-3">
            <h6>Caption</h6>
            <b-form-textarea
              v-model="form.description"
              class="form-control effect-26 mb-1"
              rows="8"
              required
            ></b-form-textarea>
          </b-form-group>
          <b-form-group class="col-12 mb-3">
            <b-form-checkbox
              switch
              v-model="form.is_vip_only"
              class="float-left"
            >
              VIP Only
            </b-form-checkbox>
            <b-form-checkbox
              switch
              v-model="form.is_pinned"
              class="float-right"
            >
              Pin Post
            </b-form-checkbox>
            <div class="clearfix"></div>
          </b-form-group>
        </b-col>

        <b-col cols="12 mt-3" v-show="form.video_raw">
          <b-row>
            <b-col cols="12" class="m-auto px-3">
              <b-button
                class="rounded-pill"
                type="submit"
                variant="primary"
                block
                :disabled="!form.video_raw"
              >
                <b-spinner small v-if="form.$busy" /> Post
              </b-button>

              <!-- API Error Message -->
              <div
                class="mt-4 text-warning"
                v-if="form.$errorMessage"
                v-text="'Uh oh, ' + form.$errorMessage.toLowerCase() + ' 😢'"
              />
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-form>
  </b-modal>
</template>

<script>
import { mapState } from 'vuex'
import Form from '@/utils/form'
import CameraRecorder from '@/views/components/CameraRecorder'
import toast from '@/mixins/toast'

export default {
  name: 'PostVideoModal',
  mixins: [toast],
  components: {
    CameraRecorder,
  },

  data() {
    return {
      is_file: false,
      form: new Form({
        hashtags: null,
        description: null,
        is_pinned: false,
        is_vip_only: false,
        video_raw: null,
        convert: true,
      }),
    }
  },

  computed: {
    ...mapState({
      user: (state) => state.auth.user,
    }),
    postModalShown: {
      get() {
        return this.$store.state.feed.post_modal_shown
      },
      set(value) {
        return this.$store.commit('feed/togglePostModal', value)
      },
    },
    hashtagItems() {
      if (!this.form.hashtags) {
        return []
      }

      return this.form.hashtags.split(' ').filter((h) => !!h)
    },
    hashtagsDisplay() {
      if (!this.hashtagItems.length) {
        return null
      }

      return this.hashtagItems.map((h) => `#${h}`).join(' ')
    },
  },

  methods: {
    async onSubmit() {
      this.form.$busy = true

      const data = this.form.$formData()
      data.set('hashtags', this.hashtagItems.join(','))

      await this.$api
        .post('influencer/feed', data)
        .then(() => {
          this.postModalShown = false
          this.successToast('Success!')
          this.$emit('reload')
        })
        .catch((error) => {
          this.form.$handleError(error)
        })
        .finally(() => {
          this.form.$busy = false
        })
    },

    onRecordFinished(video, isFile) {
      this.is_file = isFile
      this.form.video_raw = video
    },

    onModalHidden() {
      this.form.$reset()
    },
  },

  watch: {
    form() {
      this.form.$clearErrorMessage()
    },
  },
}
</script>
